<template>
  <div>
    <app-spinner v-if="!is_loaded" />
    <div v-else class="hotels-list">
      <template v-if="table_hotels_confirm.length">
        <app-cells>
          <h2 class="title">Confirm cancellation</h2>
        </app-cells>
        <template v-if="table_hotels_confirm.length">
          <div v-for="(item, index) in table_hotels_confirm" :key="`hotel_confirm_${index}`">
            <AccHotel :reservation="item.reservation" :count="index + 1" />
          </div>
        </template>
      </template>
      <template v-if="table_hotels_stop.length">
        <app-cells>
          <h2 class="title">Stop cancellation</h2>
        </app-cells>
        <template v-if="table_hotels_stop.length">
          <div v-for="(item, index) in table_hotels_stop" :key="`hotel_stop_${index}`">
            <AppAccHotel :reservation="item.reservation" :order-number="index + 1" />
          </div>
        </template>
      </template>
      <app-cells>
        <h2 class="title">New requests</h2>
      </app-cells>
      <template v-if="table_hotels_new.length">
        <div v-for="(item, index) in table_hotels_new" :key="`hotel_new_${index}`">
          <AppAccHotel :reservation="item.reservation" :order-number="index + 1" />
        </div>
      </template>
      <div v-if="!table_hotels_new.length" class="no-results no-results--margin">
        <img src="@/assets/img/schedule-plug-icon.svg" alt="">
        <div class="no-results__title">No Results</div>
        <div class="no-results__text">There’s no reservations yet</div>
      </div>
      <template v-if="table_hotels_sales_confirmation.length">
        <app-cells>
          <h2 class="title">Waiting sales confirmation</h2>
        </app-cells>
        <template v-if="table_hotels_sales_confirmation.length">
          <div v-for="(item, index) in table_hotels_sales_confirmation" :key="`hotel_waiting_${index}`">
            <AppAccHotel :reservation="item.reservation" :order-number="index + 1" />
          </div>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import { getReservationsHotelsCancellationRequests } from '@/http'
import { format, parse } from 'date-fns'
import AppAccHotel from '@/components/AppAccHotel.vue'

export default {
  name: 'HotelsCancellationsActive',
  components: { AppAccHotel },
  data() {
    return {
      is_loaded: false,
      table_hotels_confirm: [],
      table_hotels_stop: [],
      table_hotels_new: [],
      table_hotels_sales_confirmation: [],
    }
  },
  created() {
    this.fetchItems()
  },
  methods: {
    fetchItems() {
      Promise.all([
        getReservationsHotelsCancellationRequests({ sales_status: 'proceed', reservation_status__complete: false }),
        getReservationsHotelsCancellationRequests({ sales_status: 'stop', reservation_status_exclude: 'stopped' }),
        getReservationsHotelsCancellationRequests({ reservation_status: 'new' }),
        getReservationsHotelsCancellationRequests({ reservation_status__request: true, reservation_status__complete: false, sales_status_exclude: 'stop,proceed' }),
      ])
        .then(res => {
          this.table_hotels_confirm = res[0].data
          this.table_hotels_stop = res[1].data
          this.table_hotels_new = res[2].data
          this.table_hotels_sales_confirmation = res[3].data
          this.is_loaded = true
        })
    },
    getUserAvatar(crop_url) {
      if (crop_url) return crop_url
      return require('@/assets/img/temp/avatar-slug.jpg')
    },
    dateFormat(date) {
      return date ? format(parse(date, 'yyyy-MM-dd', new Date()), 'dd MMM yyyy') : ''
    },
  }
}
</script>
<style scoped lang="sass">
.hotels-list
  max-width: 1100px
</style>